import baseAPI from '@/http'

const router = 'api/Tema'
const eixoRouter = 'api/projeto/Eixo'

export const temaAPI = {
  create: (tema) => baseAPI.post(router, tema),
  update: (tema) => baseAPI.put(router, tema),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),
  listEixo: () => baseAPI.get(eixoRouter + '/get-eixo')
}
